import { ANALYZERS_ROUTES } from "@constants"
import { offices, reports, searchID } from "@signals"
import PageWrapper from "Pages/@PageWrapper"
import { resetCustomFilters, tableHideDetails } from "Pages/AnalyzersV2/@signals"
import PositionContent from "Pages/AnalyzersV2/Position/Content"
import PositionFilters from "Pages/AnalyzersV2/Position/Filters"
import React, { useEffect } from "react"
import { useLocation, useSearchParams } from "react-router-dom"
import { Box, Skeleton, Typography } from "@mui/material"
import { AppOfficesBlock } from "@components"
import PageWrapperAnalyzers from "Pages/@PageWrapper/Actions/Analyzers"
import ReportsAutocomplete from "Pages/@PageWrapper/Actions/Reports"
import { useSearchDate } from "Pages/AnalyzersV2/@hooks"
import { dsColorNew } from "@palette"


export default function PositionAnalyzer() {
	const [ searchParams ] = useSearchParams()
	const location = useLocation()
	const { date, office, isLoading } = useSearchDate()

	useEffect(() => {
		resetCustomFilters()
		// The position read is about the whole competitive set at a glance, so the
		// table starts compact and the user expands it if they need the details.
		tableHideDetails.value = true
		searchID.value = searchParams.get("idSearch")
		reports.value = searchParams.get("idReportExecution")
		offices.value = searchParams.get("idOfficePickup")
	}, [location.search])

	return <PageWrapper
		head={`DS Rentacar | ${ANALYZERS_ROUTES.POSITION_SUBTITLE}`}
		title={ANALYZERS_ROUTES.TITLE}
		subtitle={ANALYZERS_ROUTES.POSITION_SUBTITLE}
		isEmpty={false}
		showAnalyzersLinks={true}
		filters={<PositionFilters/>}
		actions={<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, whiteSpace: 'nowrap' }}>
			{!searchID.value && <Box sx={{ minWidth: { xs: 240, xl: 300 }, mr: { xs: 0.5, xl: 2 } }}>
				<ReportsAutocomplete/>
			</Box>}
			{!!searchID.value && <>
				{isLoading
					? <Skeleton variant='rounded' height={30} sx={{ borderRadius: '8px' }}/>
					: <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: 1, color: dsColorNew.textDark }}>
						<AppOfficesBlock sx={{ color: dsColorNew.black }} {...office}/> -
						<Typography variant="subtitle2" fontWeight='regular'>{date}</Typography>
					</Box>}
			</>}
			<PageWrapperAnalyzers/>
		</Box>}
	>
		<PositionContent/>
	</PageWrapper>
}
